export function Supplement(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="24"
        viewBox="0 0 18 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8 0.800003H3.20005C2.42685 0.800003 1.80005 1.4268 1.80005 2.2V4.8C1.80005 5.4957 2.30749 6.07287 2.97243 6.18159L1.98601 7.37939C1.21929 8.3104 0.800049 9.47898 0.800049 10.6851V20C0.800049 21.7673 2.23274 23.2 4.00005 23.2H14C15.7674 23.2 17.2 21.7673 17.2 20V10.6851C17.2 9.47898 16.7808 8.3104 16.0141 7.37939L15.0277 6.18159C15.6926 6.07287 16.2 5.4957 16.2 4.8V2.2C16.2 1.4268 15.5732 0.800003 14.8 0.800003ZM11.934 6.2H6.06505L3.83864 8.90508C3.47167 9.3507 3.25253 9.89738 3.20836 10.4695L3.20005 10.6851V20C3.20005 20.4418 3.55822 20.8 4.00005 20.8H14C14.4419 20.8 14.8 20.4418 14.8 20V10.6851C14.8 10.0356 14.5743 9.4064 14.1615 8.90508L11.934 6.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
